import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { BrandColors } from '@neumind/shared/branding';

const ComparisonData = [
    { feature: 'App Features (Diary, Strategies)', life: true, active: true },
    { feature: 'Family Access & Care Circle', life: true, active: true },
    { feature: 'Personal Analytics', life: true, active: true },
    { feature: 'Clinician Connection', life: false, active: true },
    { feature: 'Neuro-Education Library', life: false, active: true },
    { feature: 'Advanced Clinical Analytics', life: false, active: true },
];

export function PlanComparison() {

    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', mt: 8, mb: 4 }}>


            <TableContainer component={Paper} elevation={0} sx={{ border: 1, borderColor: 'divider', borderRadius: 3 }}>
                <Table>
                    <TableHead sx={{ bgcolor: 'grey.50' }}>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 700, width: '40%', fontSize: '1rem', pl: 3 }}>Feature</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 700, width: '30%', fontSize: '1rem' }}>
                                Neumind Life
                                <Typography variant="caption" display="block" color="text.secondary">Maintenance</Typography>
                            </TableCell>
                            <TableCell align="center" sx={{ fontWeight: 700, width: '30%', fontSize: '1rem', color: BrandColors.primary.main }}>
                                Neumind Active
                                <Typography variant="caption" display="block" color="primary.main">Rehab</Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {ComparisonData.map((row, index) => (
                            <TableRow key={row.feature} sx={{ '&:last-child td, &:last-child th': { border: 0 }, bgcolor: index % 2 === 0 ? 'background.paper' : 'grey.50' }}>
                                <TableCell component="th" scope="row" sx={{ fontWeight: 500, fontSize: '0.95rem', pl: 3, color: 'text.primary' }}>
                                    {row.feature}
                                </TableCell>
                                <TableCell align="center">
                                    {row.life ? (
                                        <CheckCircleIcon color="success" />
                                    ) : (
                                        <CancelIcon sx={{ color: 'grey.300' }} />
                                    )}
                                </TableCell>
                                <TableCell align="center">
                                    {row.active ? (
                                        <CheckCircleIcon color="primary" />
                                    ) : (
                                        <CancelIcon sx={{ color: 'grey.300' }} />
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}
